import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';
import { getRoleLevel, IUser, IUserApiModel } from './User.model';

export interface IMembersAuth0 extends IUser {
  picture: string;
  auth0Name: string;
  userInvite?: {
    user: IUser;
  };
}

export interface IMembersAuth0ApiModel extends IUserApiModel {
  picture: string;
  auth0Name: string;
  userInvite?: {
    user: IUser;
  };
}

export default class MembersAuth0 implements IMembersAuth0 {
  public readonly id: string;

  public readonly name: string;

  public readonly email: string;

  public readonly auth0Id: string;

  public readonly avatarId: string;

  public readonly userInviteId: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  public readonly role: string;

  public readonly blocked: boolean;

  public readonly picture: string;

  public readonly auth0Name: string;

  public readonly roleLevel: number;

  constructor(
    id: string,
    name: string,
    email: string,
    auth0Id: string,
    avatarId: string,
    userInviteId: string,
    createdAt: Date,
    updatedAt: Date,
    role: string,
    blocked: boolean,
    picture: string,
    auth0Name: string,
    roleLevel: number,
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.auth0Id = auth0Id;
    this.avatarId = avatarId;
    this.userInviteId = userInviteId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.role = role;
    this.blocked = blocked;
    this.picture = picture;
    this.auth0Name = auth0Name;
    this.roleLevel = roleLevel;
  }

  static fromApiModel(apiModel: IMembersAuth0ApiModel) {
    const {
      id,
      name,
      email,
      auth0Id,
      avatarId,
      userInviteId,
      role,
      blocked,
      auth0Name,
    } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));
    const picture = updateBeamUrl(apiModel.picture);
    const roleLevel = getRoleLevel(role);

    return new MembersAuth0(
      id,
      name,
      email,
      auth0Id,
      avatarId,
      userInviteId,
      createdAt,
      updatedAt,
      role,
      blocked,
      picture,
      auth0Name,
      roleLevel,
    );
  }

  static arrayFromApiModel(arrayApiModel: IMembersAuth0ApiModel[]) {
    const array = arrayApiModel.map(apiModel =>
      MembersAuth0.fromApiModel(apiModel),
    );

    return array;
  }
}
